import PrecoPromocional from '../../../components/PrecoPromocional';
import { ofertaProduto, ofertaSaborPizza } from '../../../Utils/ofertaProduto';
import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonLoading, IonModal, IonRadio, IonRadioGroup, IonRow, IonTextarea, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { add, arrowBack, chevronBack, chevronForward, remove } from 'ionicons/icons';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { buildCartItem, cartSchedule, ProductRequest } from '../../../Utils/cartItem';
import { cartProductAvailable, cartReferenceDate } from '../../../Utils/cartAvailability';
import { empresaComPrecosVigentes, precoProdutoVigente } from '../../../Utils/promocao';
import { complementOptionMaximum, complementSelectionValid } from '../../../Utils/complementLimits';
import ProductBadges from '../../../components/ProductBadges';
import useAnalytics from '../../../hooks/useAnalytics';
import "./OrdensProdutosCompor.css";
import imgDefaultImage from './imgs/defaultImage.svg';
import imgDefaultImageNoBorder from './imgs/defaultImageNoBorder.svg';

type MyModalProps = {
  empresa: any;
  disabled: any;
  adicionarItem: Function;
  selectedCategoria?: string;
  onCategoriaChange?: (categoria: string) => void;
  productRequest?: ProductRequest | null;
}

const OrdensProdutosCompor: React.FC<MyModalProps> = (props: MyModalProps) => {

  const analytics = useAnalytics();

  // ===== ESTADOS DE UI/MODAIS =====
  const [showLoading, setShowLoading] = useState(false);
  const [showComplementos, setShowComplementos] = useState(false);
  const [showSaboresPizza, setShowSaboresPizzaV2] = useState(false);
  const [showDestaquePizzaModal, setShowDestaquePizzaModal] = useState(false);
  const [destaquePizzaProduto, setDestaquePizzaProduto] = useState<any>(null);
  const [produtoModalComplemento, setProdutoModalComplemento] = useState<any>(null);
  const [quantidadeModalComplemento, setQuantidadeModalComplemento] = useState<number>(1);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  // ===== DADOS DA EMPRESA =====
  const [dadosEmpresaOriginais, setDadosEmpresa] = useState<any>();
  const [relogioPromocao, setRelogioPromocao] = useState(() => Date.now());
  const agendamentoPromocao = JSON.stringify(cartSchedule() || null);
  const referenciaPromocao = useMemo(() => cartReferenceDate(JSON.parse(agendamentoPromocao), new Date(relogioPromocao)),
    [agendamentoPromocao, relogioPromocao]);
  const dadosEmpresa = useMemo(() => empresaComPrecosVigentes(dadosEmpresaOriginais, referenciaPromocao),
    [dadosEmpresaOriginais, referenciaPromocao]);
  useEffect(() => {
    const timer = window.setInterval(() => setRelogioPromocao(Date.now()), 60000);
    return () => window.clearInterval(timer);
  }, []);
  const [listaItemCatalogoProdutosCompor, setListaItemCatalogoProdutosCompor] = useState<any>([]);
  const [listaItemCatalogoProdutosComplementos, setListaItemCatalogoProdutosComplementos] = useState<any>([]);

  // ===== SELEÇÃO DE CATEGORIA E PRODUTOS =====
  const [selectedCategoria, setSelectedCategoria] = useState<any>(props.selectedCategoria || '');
  const [selectedCategoriaObject, setSelectedCategoriaObject] = useState<any>(null);
  const [selectedSize, setSelectedSize] = useState<any>();
  const [selectedCount, setSelectedCount] = useState<any>();
  const [selectedProdutos, setSelectedProdutos] = useState<string[]>([]);
  const [listaComporItemsSelecionados, setListaComporItemsSelecionados] = useState<any>([]);
  const [categoriaExpandida, setCategoriaExpandida] = useState<string | null>(null);
  const [selectedPizzaTamanhoPorCategoria, setSelectedPizzaTamanhoPorCategoria] = useState<{ [categoria: string]: string }>({});
  const [pizzaTamanhoScrollState, setPizzaTamanhoScrollState] = useState<{
    [categoria: string]: { canLeft: boolean; canRight: boolean };
  }>({});

  // ===== COMPLEMENTOS E EXTRAS =====
  const [grupoComplementos, setGrupoComplementos] = useState<any>();
  const [updatedItensSelecionadosComplementos, setUpdatedItensSelecionadosComplementos] = useState<any>([]);
  const [selectedMassa, setSelectedMassa] = useState<any>();
  const [selectedBorda, setSelectedBorda] = useState<any>();
  const [checkedCobrarPorMaiorValor, setCheckedCobrarPorMaiorValor] = useState<any>();
  const [itemSelecionadoMassa, setItemSelecionadoMassa] = useState<any>();
  const [itemSelecionadoBorda, setItemSelecionadoBorda] = useState<any>();

  // ===== VALORES E CÁLCULOS =====
  const [valor, setValor] = useState<any>();
  const [subtotal, setSubtotal] = useState<any>();

  // ===== OBSERVAÇÕES E DETALHES =====
  const [observacao, setObservacao] = useState("");
  const [unidadeMedida, setUnidadeMedida] = useState("");
  const [peso, setPeso] = useState("");

  // ===== REFS =====
  const pesoInputRef = useRef<any>(null);
  const complementosContentRef = useRef<HTMLIonContentElement | null>(null);
  const pizzaTamanhoTabsRefs = useRef<{ [categoria: string]: HTMLDivElement | null }>({});

  const getNomeCategoriaExibicao = (categoria: any) => {
    return categoria?.nome || "Item";
  };

  const formatarTamanhoOpcao = (tamanho: any) => {
    const texto = String(tamanho || "").trim();
    return texto ? `${texto.charAt(0).toLocaleUpperCase("pt-BR")}${texto.slice(1)}` : "";
  };

  const formatarNomeOpcaoComposta = (tamanho: any, quantidadeSabores: any) => {
    const sabores = Math.max(1, Number(quantidadeSabores) || 1);
    return [
      formatarTamanhoOpcao(tamanho),
      `${sabores} ${sabores === 1 ? "sabor" : "sabores"}`
    ].filter(Boolean).join(" · ");
  };

  const atualizarNavegacaoTamanhosPizza = (categoriaNome: string) => {
    const tabsElement = pizzaTamanhoTabsRefs.current[categoriaNome];
    if (!tabsElement) return;

    const tolerance = 2;
    const nextState = {
      canLeft: tabsElement.scrollLeft > tolerance,
      canRight: tabsElement.scrollLeft + tabsElement.clientWidth < tabsElement.scrollWidth - tolerance
    };

    setPizzaTamanhoScrollState((prev) => {
      const currentState = prev[categoriaNome];
      if (currentState?.canLeft === nextState.canLeft && currentState?.canRight === nextState.canRight) {
        return prev;
      }

      return {
        ...prev,
        [categoriaNome]: nextState
      };
    });
  };

  const navegarTamanhosPizza = (categoriaNome: string, direction: -1 | 1) => {
    const tabsElement = pizzaTamanhoTabsRefs.current[categoriaNome];
    if (!tabsElement) return;

    const firstTab = tabsElement.querySelector('.pizza-tamanho-tab') as HTMLElement | null;
    const computedStyle = window.getComputedStyle(tabsElement);
    const gap = Number.parseFloat(computedStyle.columnGap || computedStyle.gap) || 10;
    const tabWidth = firstTab?.getBoundingClientRect().width || tabsElement.clientWidth / 3;

    tabsElement.scrollBy({
      left: direction * (tabWidth + gap),
      behavior: 'smooth'
    });

    window.setTimeout(() => atualizarNavegacaoTamanhosPizza(categoriaNome), 350);
  };

  const getProdutoModalImagem = () => {
    if (selectedCategoriaObject?.tipo === "pizzas" && selectedCount > 1) {
      return null;
    }

    if (produtoModalComplemento?.urlImagem) {
      return produtoModalComplemento.urlImagem;
    }

    return null;
  };

  const getProdutoModalTitulo = () => {
    if (selectedCategoriaObject?.tipo === "pizzas" && selectedCount > 1) {
      return formatarNomeOpcaoComposta(selectedSize, selectedCount);
    }

    if (produtoModalComplemento?.nome || produtoModalComplemento?.name) {
      return produtoModalComplemento.nome || produtoModalComplemento.name;
    }

    if (selectedCategoriaObject?.tipo === "pizzas" && selectedSize) {
      return formatarTamanhoOpcao(selectedSize);
    }

    return selectedCategoriaObject?.nome || "";
  };

  const getProdutoModalDescricao = () => {
    return produtoModalComplemento?.descricao || null;
  };

  const getProdutoModalSaboresPills = () => {
    if (selectedCategoriaObject?.tipo !== "pizzas" || selectedCount <= 1) {
      return [];
    }

    if (selectedProdutos.length > 0) {
      return selectedProdutos;
    }

    return listaComporItemsSelecionados
      .map((item: any) => item.descricao)
      .filter(Boolean);
  };

  const parseValorPtBr = (value: any): number => {
    if (value === null || value === undefined || value === "") return 0;

    if (typeof value === "number") return value;

    return Number(
      String(value)
        .replace(/\./g, "")
        .replace(",", ".")
    ) || 0;
  };

  const formatValorPtBr = (value: number): string => {
    return value.toLocaleString("pt-br", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const getSubtotalUnitarioModal = (): number => {
    return parseValorPtBr(subtotal || valor || "0");
  };

  const getTotalModalComQuantidade = (): string => {
    return formatValorPtBr(getSubtotalUnitarioModal() * quantidadeModalComplemento);
  };

  useEffect(() => {
    if (props.empresa) {
      console.log('[DEBUG] props.empresa recebida', {
        categorias: props.empresa.categoriaProdutos?.length ?? 0,
        catalogo: props.empresa.catalogoProdutos?.length ?? 0
      });
      setDadosEmpresa(props.empresa);
      // Carregar todos os itens do cardápio seguindo a lógica JavaScript
      loadAllMenuItems(empresaComPrecosVigentes(props.empresa, referenciaPromocao));
    }
  }, [props.empresa, referenciaPromocao]);


  useEffect(() => {
    if (props.selectedCategoria && props.selectedCategoria !== selectedCategoria) {
      setSelectedCategoria(props.selectedCategoria);
    }
  }, [props.selectedCategoria]);

  const isProdutoDisponivel = (produto: any) => cartProductAvailable(produto);

  const getCatalogoProdutos = () => dadosEmpresa?.catalogoProdutos || props.empresa?.catalogoProdutos || [];

  const findCatalogProductById = (produtoId?: string) => {
    if (!produtoId) return null;
    return getCatalogoProdutos().find((produto: any) => produto.id === produtoId) || null;
  };

  const getProdutoDestaques = (produto: any) => {
    return (produto?.id ? findCatalogProductById(produto.id) : produto)?.destaquesProduto;
  };

  const isGrupoItemDisponivel = (item: any) => {
    if (!item?.id) return true;

    const produtoCatalogo = findCatalogProductById(item.id);
    if (!produtoCatalogo) return true;

    return isProdutoDisponivel(produtoCatalogo);
  };

  const getGrupoItensDisponiveis = (grupo: any) => {
    return (grupo?.itens || []).filter((item: any) => item.ativo !== false && complementOptionMaximum(grupo, item) > 0 && isGrupoItemDisponivel(item));
  };

  const getSequenciaGruposComplemento = (): string[] => {
    const sequencia: string[] = [];

    if (selectedCategoriaObject?.tipo === "pizzas") {
      if ((selectedCategoriaObject?.massas?.length || 0) > 0) {
        sequencia.push("complemento-group-massa");
      }

      if ((selectedCategoriaObject?.bordas?.length || 0) > 0) {
        sequencia.push("complemento-group-borda");
      }
    }

    (grupoComplementos || []).forEach((_: any, idx: number) => {
      sequencia.push(`complemento-group-${idx}`);
    });

    return sequencia;
  };

  const avancarParaProximoGrupo = (currentGroupId: string) => {
    const sequencia = getSequenciaGruposComplemento();
    const currentIndex = sequencia.indexOf(currentGroupId);

    if (currentIndex === -1 || currentIndex === sequencia.length - 1) {
      return;
    }

    const nextGroupId = sequencia[currentIndex + 1];

    setTimeout(async () => {
      const nextElement = document.getElementById(nextGroupId);

      if (!nextElement || !complementosContentRef.current) {
        return;
      }

      try {
        const desktopPanel = complementosContentRef.current.querySelector(
          ".complementos-desktop-panel"
        ) as HTMLElement | null;
        const scrollElement = window.matchMedia("(min-width: 1024px)").matches && desktopPanel
          ? desktopPanel
          : await complementosContentRef.current.getScrollElement();

        const nextRect = nextElement.getBoundingClientRect();
        const scrollRect = scrollElement.getBoundingClientRect();

        const offsetTop = nextRect.top - scrollRect.top;
        const targetTop = Math.max(0, scrollElement.scrollTop + offsetTop - 8);

        scrollElement.scrollTo({
          top: targetTop,
          behavior: "smooth",
        });
      } catch (error) {
        nextElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 150);
  };

  const focarGrupoObrigatorio = async (groupIndex: number) => {
    const content = complementosContentRef.current;
    const group = content?.querySelector<HTMLElement>(`#complemento-group-${groupIndex}`);
    if (!content || !group) return;

    group.focus({ preventScroll: true });

    try {
      const desktopPanel = content.querySelector<HTMLElement>(".complementos-desktop-panel");
      const scrollElement = window.matchMedia("(min-width: 1024px)").matches && desktopPanel
        ? desktopPanel
        : await content.getScrollElement();
      const offsetTop = group.getBoundingClientRect().top - scrollElement.getBoundingClientRect().top;
      scrollElement.scrollTo({
        top: Math.max(0, scrollElement.scrollTop + offsetTop - 12),
        behavior: "smooth"
      });
    } catch {
      group.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const prepareGrupoComplementos = (grupos: any[] = []) => {
    return grupos
      .map((grupo: any, sourceGroupIndex: number) => ({
        ...grupo,
        sourceGroupIndex,
        selectedItem: null,
        selectedItems: [],
        itens: getGrupoItensDisponiveis(grupo)
          .map((item: any) => ({
            ...item,
            sourceOptionIndex: (grupo.itens || []).indexOf(item),
            selected: false,
          }))
      }))
      .filter((grupo: any) => grupo.itens.length > 0);
  };

  // Função para carregar todos os itens do cardápio seguindo a lógica JavaScript
  const loadAllMenuItems = (empresa: any) => {
    if (empresa?.catalogoProdutos) {
      let produtosDisponiveis = empresa.catalogoProdutos.filter((produto: any) => isProdutoDisponivel(produto));

      console.log('[DEBUG] loadAllMenuItems -> produtosDisponiveis.count:', produtosDisponiveis.length);
      setListaItemCatalogoProdutosCompor(produtosDisponiveis);

      // Carregar lista de complementos disponíveis para verificações e montagem da UI
      setListaItemCatalogoProdutosComplementos(empresa.catalogoProdutos.filter((value: any) => {
        return value.tipo === "complementos" && isProdutoDisponivel(value);
      }));
    }
  };

  // Função para agrupar produtos por categoria
  const agruparProdutosPorCategoria = (produtos: any[]) => {
    let categorias: { [key: string]: any[] } = {};
    produtos.forEach(produto => {
      if (!categorias[produto.categoria]) {
        categorias[produto.categoria] = [];
      }
      categorias[produto.categoria].push(produto);
    });
    return categorias;
  };

  // ✅ Função para verificar se uma categoria deve ser exibida
  const shouldShowCategory = (categoria: any, produtosDaCategoria: any[]) => {
    // Filtrar produtos que estão disponíveis (já filtrados por estoque em loadAllMenuItems)
    const produtosDisponiveis = produtosDaCategoria.filter((produto: any) => isProdutoDisponivel(produto));

    // A categoria só deve ser exibida se tiver pelo menos um produto disponível
    return produtosDisponiveis.length > 0;
  };

  // Função para renderizar produtos agrupados por categoria (versão lista)
  const renderProdutos = () => {
    if (!dadosEmpresa?.catalogoProdutos || !listaItemCatalogoProdutosCompor.length) {
      return null;
    }

    // Filtrar produtos disponíveis online
    let produtosDisponiveis = dadosEmpresa.catalogoProdutos.filter((produto: any) => isProdutoDisponivel(produto));

    // Agrupar produtos por categoria
    let categoriasAgrupadas = agruparProdutosPorCategoria(produtosDisponiveis);

    // Filtrar produtos em destaque
    const produtosDestaque = produtosDisponiveis.filter((produto: any) => produto.destaque === true && produto.tipo !== "complementos");

    return (
      <div className="catalogo-produtos" style={{ width: '100%' }}>

        {/* Seção de Destaques */}
        {produtosDestaque.length > 0 && (
          <div style={{ marginBottom: '20px' }}>
            <h2 className="catalogo-categoria-titulo catalogo-destaques-titulo">
              Destaques
            </h2>
            <div className="destaques-scroll-container">

              {console.log("produtosDestaque", produtosDestaque)}
              {produtosDestaque.map((produto: any, index: number) => {
                const oferta = ofertaProduto(produto, referenciaPromocao);
                // Determinar preço de exibição
                const isPizza = produto.tipo === "pizzas";
                let precoDisplay = '';
                if (isPizza && produto.valores && Array.isArray(produto.valores) && produto.valores.length > 0) {
                  const menorPreco = Math.min(
                    ...produto.valores
                      .map((v: any) => parseFloat(String(v.valor).replace(/\./g, '').replace(',', '.')))
                      .filter((v: number) => !isNaN(v) && v > 0)
                  );
                  precoDisplay = menorPreco !== Infinity
                    ? `A partir de R$ ${menorPreco.toFixed(2).replace('.', ',')}`
                    : '';
                } else if (produto.valor && produto.valor !== "0,00") {
                  precoDisplay = `R$ ${produto.valor}`;
                } else if (produto.grupoComplementos?.[0]?.itens) {
                  const menorPreco = produto.grupoComplementos[0].itens
                    .map((item: any) => parseFloat(String(item.price).replace('.', '').replace(',', '.')))
                    .reduce((min: number, price: number) => Math.min(min, price), Infinity);
                  precoDisplay = `A partir de R$ ${menorPreco.toFixed(2).replace('.', ',')}`;
                } else {
                  precoDisplay = 'Consulte';
                }

                return (
                  <div
                    key={`destaque-${index}`}
                    className="destaque-card"
                    onClick={() => handleDestaqueClick(produto)}
                  >
                    <div className="destaque-card-media">
                      {produto.urlImagem ? (
                        <img
                          src={produto.urlImagem}
                          alt={produto.nome}
                          className="destaque-card-img"
                        />
                      ) : (
                        <img
                          className="destaque-card-img-placeholder"
                          src={imgDefaultImageNoBorder}
                        />
                      )}
                      <ProductBadges badges={produto.destaquesProduto} />
                    </div>
                    <div className="destaque-card-info">
                      {oferta ? <PrecoPromocional oferta={oferta} destaque /> : <span className="destaque-card-preco">
                        {precoDisplay.startsWith('A partir de ')
                          ? <><span style={{ fontWeight: 'normal' }}>A partir de </span>{precoDisplay.slice('A partir de '.length)}</>
                          : precoDisplay}
                      </span>}
                      <span className="destaque-card-nome">{produto.nome}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Container principal para os produtos */}
        <div className="catalogo-categorias">
          {dadosEmpresa.categoriaProdutos
            .filter((categoria: any) => {
              // Filtro 1: Não mostrar complementos
              if (categoria.tipo === "complementos") return false;

              // Filtro 2: Verificar se a categoria tem produtos disponíveis
              const produtosDaCategoria = categoriasAgrupadas[categoria.nome] || [];
              return shouldShowCategory(categoria, produtosDaCategoria);
            })
            .map((categoria: any, index: number) => (
              <section key={index} id={`category-${categoria.nome}`} className="catalogo-categoria">
                <h2 className="catalogo-categoria-titulo">
                  {getNomeCategoriaExibicao(categoria)}
                </h2>

                {/* Lógica especial para pizzas - mostrar por tamanhos */}
                {categoria.tipo === "pizzas" ? (
                  <div className="catalogo-produto-grid catalogo-produto-grid-pizzas">
                    {(() => {
                      const tamanhosPizza = categoria.tamanhos || [];
                      if (tamanhosPizza.length <= 1) return null;

                      const tamanhoSelecionado = selectedPizzaTamanhoPorCategoria[categoria.nome] || tamanhosPizza[0]?.name;
                      const mostrarNavegacao = tamanhosPizza.length > 3;
                      const navigationState = pizzaTamanhoScrollState[categoria.nome] || {
                        canLeft: false,
                        canRight: mostrarNavegacao
                      };

                      const tamanhoTabs = (
                        <div
                          className="pizza-tamanho-tabs"
                          ref={(element) => {
                            pizzaTamanhoTabsRefs.current[categoria.nome] = element;
                          }}
                          onScroll={() => atualizarNavegacaoTamanhosPizza(categoria.nome)}
                        >
                          {tamanhosPizza.map((tamanho: any) => {
                            const ativo = tamanho.name === tamanhoSelecionado;

                            return (
                              <button
                                key={`pizza-tab-${categoria.nome}-${tamanho.name}`}
                                type="button"
                                className={`pizza-tamanho-tab ${ativo ? 'pizza-tamanho-tab-ativo' : ''}`}
                                onClick={(event) => {
                                  setSelectedPizzaTamanhoPorCategoria((prev) => ({
                                    ...prev,
                                    [categoria.nome]: tamanho.name
                                  }));
                                  event.currentTarget.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'nearest',
                                    inline: 'center'
                                  });
                                }}
                              >
                                <span>{tamanho.name}</span>
                              </button>
                            );
                          })}
                        </div>
                      );

                      return (
                        <>
                          {mostrarNavegacao ? (
                            <div className="pizza-tamanho-carousel">
                              {navigationState.canLeft && (
                                <button
                                  type="button"
                                  className="pizza-tamanho-nav pizza-tamanho-nav-left"
                                  aria-label="Ver tamanhos anteriores"
                                  onClick={() => navegarTamanhosPizza(categoria.nome, -1)}
                                >
                                  <IonIcon icon={chevronBack} />
                                </button>
                              )}

                              {tamanhoTabs}

                              {navigationState.canRight && (
                                <button
                                  type="button"
                                  className="pizza-tamanho-nav pizza-tamanho-nav-right"
                                  aria-label="Ver próximos tamanhos"
                                  onClick={() => navegarTamanhosPizza(categoria.nome, 1)}
                                >
                                  <IonIcon icon={chevronForward} />
                                </button>
                              )}
                            </div>
                          ) : tamanhoTabs}

                          {/* <div className="pizza-tamanho-info">
                            <IonIcon icon={informationCircleOutline} />
                            <span>
                              Você está vendo as opções de tamanho <strong>{tamanhoSelecionado}</strong>
                            </span>
                          </div> */}
                        </>
                      );
                    })()}

                    {categoria.tamanhos?.map((tamanho: any, tamanhoIndex: number) => {
                      const tamanhosPizza = categoria.tamanhos || [];
                      const tamanhoSelecionado = selectedPizzaTamanhoPorCategoria[categoria.nome] || tamanhosPizza[0]?.name;

                      if (tamanhosPizza.length > 1 && tamanho.name !== tamanhoSelecionado) return null;

                      // Gerar todas as combinações de sabores para este tamanho
                      const combinacoes = [];
                      const mostrarSubcategoriaTamanho = false;

                      // Item simples (1 sabor)
                      combinacoes.push({
                        nome: formatarNomeOpcaoComposta(tamanho.name, 1),
                        sabores: 1,
                        tamanho: tamanho.name
                      });

                      // Combinacoes dinamicas para N sabores
                      const maxSabores = Number(tamanho.sabores) || 1;
                      for (let n = 2; n <= maxSabores; n++) {
                        combinacoes.push({
                          nome: formatarNomeOpcaoComposta(tamanho.name, n),
                          sabores: n,
                          tamanho: tamanho.name
                        });
                      }

                      return (
                        <React.Fragment key={`pizza-tamanho-${tamanho.name}-${tamanhoIndex}`}>
                          {mostrarSubcategoriaTamanho && (
                            <div
                              style={{
                                marginTop: tamanhoIndex === 0 ? 0 : '8px',
                                padding: '8px 12px',
                                backgroundColor: 'var(--pedido-gray-surface)',
                                borderRadius: '8px',
                                color: 'var(--pedido-text-primary)',
                                fontSize: '15px',
                                fontWeight: 700,
                                letterSpacing: 0,
                                textTransform: 'uppercase'
                              }}
                            >
                              {tamanho.name}
                            </div>
                          )}

                          {combinacoes.map((combinacao: any, comboIndex: number) => {
                            // Calcular menor preço para este tamanho
                            const produtosPizza = categoriasAgrupadas[categoria.nome] || [];
                            const precosTamanho = produtosPizza
                              .filter((produto: any) => produto.valores?.some((v: any) => v.name === tamanho.name))
                              .map((produto: any) => {
                                const valorTamanho = produto.valores?.find((v: any) => v.name === tamanho.name);
                                return valorTamanho ? parseFloat(valorTamanho.valor.replace(',', '.')) : Infinity;
                              })
                              .filter((preco: number) => Number.isFinite(preco));

                            if (precosTamanho.length === 0) return null;

                            const menorPreco = Math.min(...precosTamanho);
                            const precoFormatado = menorPreco.toFixed(2).replace('.', ',');

                            return (
                              <div
                                key={`${tamanhoIndex}-${comboIndex}`}
                                className="catalogo-produto-card"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '10px',
                                  border: '1px solid var(--pedido-gray-border)',
                                  borderRadius: '8px',
                                  backgroundColor: 'white',
                                  cursor: 'pointer'
                                }}
                                onClick={() => {
                                  console.log('[DEBUG] clique combinacao pizza -> intenção de abrir modal', {
                                    categoriaNome: categoria.nome,
                                    combinacao,
                                    categoriaObj: categoria
                                  });

                                  setSelectedProdutos([]); // Limpar produtos selecionados

                                  setSelectedCategoria(categoria.nome);
                                  setSelectedCategoriaObject(categoria);
                                  setSelectedSize(combinacao.tamanho);
                                  setSelectedCount(combinacao.sabores);
                                  setCheckedCobrarPorMaiorValor(categoria.cobrarMaiorValor || false);
                                  setCategoriaExpandida(categoria.nome);
                                  setShowSaboresPizzaV2(true);

                                  // log dos valores pretendidos (os setState são async — aqui mostramos o que estamos setando)
                                  console.log('[DEBUG] valores pretendidos setados (nota: setState é async):', {
                                    selectedCategoriaToSet: categoria.nome,
                                    selectedSizeToSet: combinacao.tamanho,
                                    selectedCountToSet: combinacao.sabores
                                  });
                                }}
                              >
                                <div style={{ flex: 1 }}>
                                  <h3 style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    marginBottom: '5px',
                                    margin: 0,
                                    color: 'var(--pedido-text-primary)'
                                  }}>
                                    {combinacao.nome}
                                  </h3>
                                  <div style={{ fontSize: '14px', color: 'var(--pedido-text-primary)' }}>
                                    A partir de <span style={{ fontWeight: 'bold' }}>R$ {precoFormatado}</span>
                                  </div>
                                </div>

                                {/* Imagem da pizza */}
                                {categoria.urlImagem ? (
                                  <div
                                    style={{
                                      position: 'relative',
                                      width: '100px',
                                      height: '100px',
                                      // marginLeft: '10px',
                                      borderRadius: '50%',
                                      overflow: 'hidden',
                                      backgroundColor: 'var(--pedido-gray-surface)',
                                      flexShrink: 0
                                    }}
                                  >
                                    {(() => {
                                      const n = combinacao.sabores;
                                      const imageUrl = categoria.urlImagem;
                                      const size = 80;
                                      const cx = size / 2;
                                      const cy = size / 2;
                                      const r = size / 2;

                                      if (n === 1) {
                                        return (
                                          <img
                                            src={imageUrl}
                                            alt={combinacao.nome}
                                            style={{
                                              width: '100%',
                                              height: '100%',
                                              objectFit: 'cover'
                                            }}
                                          />
                                        );
                                      }

                                      const anglePer = 360 / n;
                                      let startBase = -90;

                                      if (n === 2) startBase = 0;     // linha horizontal

                                      const separatorWidth = 3;
                                      const separatorColor = '#fff';

                                      const polarToCartesian = (angleDeg: number) => {
                                        const rad = (angleDeg * Math.PI) / 180;
                                        return {
                                          x: cx + r * Math.cos(rad),
                                          y: cy + r * Math.sin(rad)
                                        };
                                      };

                                      const makeSlicePath = (startDeg: number, endDeg: number) => {
                                        const p1 = polarToCartesian(startDeg);
                                        const p2 = polarToCartesian(endDeg);
                                        const largeArcFlag = endDeg - startDeg > 180 ? 1 : 0;

                                        return `
                                      M ${cx} ${cy}
                                      L ${p1.x} ${p1.y}
                                      A ${r} ${r} 0 ${largeArcFlag} 1 ${p2.x} ${p2.y}
                                      Z
                                    `;
                                      };

                                      return (
                                        <svg
                                          width={size}
                                          height={size}
                                          viewBox={`0 0 ${size} ${size}`}
                                          xmlns="http://www.w3.org/2000/svg"
                                          style={{
                                            display: 'block',
                                            width: '100%',
                                            height: '100%'
                                          }}
                                        >
                                          <defs>
                                            {Array.from({ length: n }).map((_, i) => {
                                              const a1 = startBase + anglePer * i;
                                              const a2 = startBase + anglePer * (i + 1);

                                              return (
                                                <clipPath
                                                  key={`clip-${i}`}
                                                  id={`pizza-slice-${combinacao.nome?.replace(/\s+/g, '-') || 'item'}-${i}`}
                                                  clipPathUnits="userSpaceOnUse"
                                                >
                                                  <path d={makeSlicePath(a1, a2)} />
                                                </clipPath>
                                              );
                                            })}
                                          </defs>

                                          {Array.from({ length: n }).map((_, i) => (
                                            <g
                                              key={`slice-${i}`}
                                              clipPath={`url(#pizza-slice-${combinacao.nome?.replace(/\s+/g, '-') || 'item'}-${i})`}
                                            >
                                              <image
                                                href={imageUrl}
                                                x="0"
                                                y="0"
                                                width={size}
                                                height={size}
                                                preserveAspectRatio="xMidYMid slice"
                                              />
                                            </g>
                                          ))}

                                          {Array.from({ length: n }).map((_, i) => {
                                            const angle = startBase + anglePer * i;
                                            const p = polarToCartesian(angle);

                                            return (
                                              <line
                                                key={`line-${i}`}
                                                x1={cx}
                                                y1={cy}
                                                x2={p.x}
                                                y2={p.y}
                                                stroke={separatorColor}
                                                strokeWidth={separatorWidth}
                                                strokeLinecap="butt"
                                              />
                                            );
                                          })}
                                        </svg>
                                      );
                                    })()}
                                    <div
                                      style={{
                                        position: 'absolute',
                                        bottom: '14px',
                                        right: '14px',
                                        backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                                        borderRadius: '50%',
                                        width: '28px',
                                        height: '28px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '1px solid white',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                      }}
                                    >
                                      <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                                    </div>
                                  </div>
                                ) : (
                                  <div style={{ position: 'relative', marginLeft: '10px', flexShrink: 0 }}>
                                    <img
                                      src={imgDefaultImage}
                                      // alt={produto.nome}
                                      style={{
                                        width: '100px',
                                        height: '100px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        display: 'block'
                                      }}
                                    />
                                    <div
                                      style={{
                                        position: 'absolute',
                                        bottom: '5px',
                                        right: '5px',
                                        backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                                        borderRadius: '50%',
                                        width: '28px',
                                        height: '28px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '1px solid white',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                      }}
                                    >
                                      <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}
                  </div>
                ) : (
                  /* Para outras categorias, mostrar produtos normalmente (somente itens disponíveis) */
                  <div className="catalogo-produto-grid">
                    {categoriasAgrupadas[categoria.nome]
                      ?.filter((produto: any) => isProdutoDisponivel(produto))
                      .map((produto: any, prodIndex: number) => (
                        <div
                          key={prodIndex}
                          className="catalogo-produto-card"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '10px',
                            border: '1px solid var(--pedido-gray-border)',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            cursor: 'pointer'
                          }}
                          onClick={() => handleProdutoClick(produto)}
                        >
                          <div style={{ flex: 1, minWidth: 0 }}>
                            {/* Nome do produto */}
                            <h3 style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              marginBottom: '5px',
                              margin: 0,
                              color: 'var(--pedido-text-primary)'
                            }}>
                              {produto.nome}
                            </h3>

                            <ProductBadges badges={produto.destaquesProduto} />

                            {/* Descrição do produto */}
                            {produto.descricao && (
                              <p style={{
                                fontSize: '13px',
                                color: 'var(--pedido-text-secondary)',
                                padding: '5px 5px 5px 0px',
                                marginBottom: '5px',
                                margin: 0
                              }}>
                                {produto.descricao}
                              </p>
                            )}

                            {/* Preço do produto */}
                            <div style={{ fontSize: '14px', color: 'var(--pedido-text-primary)' }}>
                              {ofertaProduto(produto, referenciaPromocao) ? <PrecoPromocional oferta={ofertaProduto(produto, referenciaPromocao)!} /> : produto.valor !== "0,00" ? (
                                <span style={{ fontWeight: 'bold' }}>{`R$ ${produto.valor}`}</span>
                              ) : (
                                produto.grupoComplementos?.[0]?.itens ? (
                                  (() => {
                                    const grupoComplemento = produto.grupoComplementos[0];
                                    const menorPreco = grupoComplemento.itens
                                      .map((item: any) => parseFloat(item.price.replace('.', '').replace(',', '.')))
                                      .reduce((min: number, price: number) => Math.min(min, price), Infinity);
                                    const precoFormatado = menorPreco.toFixed(2).replace('.', ',');
                                    return <span>A partir de <span style={{ fontWeight: 'bold' }}>R$ {precoFormatado}</span></span>;
                                  })()
                                ) : (
                                  'Preço sob consulta'
                                )
                              )}
                            </div>
                          </div>

                          {/* Imagem do produto */}
                          {produto.urlImagem ? (
                            <div style={{ position: 'relative', marginLeft: '10px', flexShrink: 0 }}>
                              <img
                                src={produto.urlImagem}
                                alt={produto.nome}
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'cover',
                                  borderRadius: '8px',
                                  display: 'block'
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: '5px',
                                  right: '5px',
                                  backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                                  borderRadius: '50%',
                                  width: '28px',
                                  height: '28px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid white',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}
                              >
                                <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                              </div>
                            </div>
                          ) : (
                            <div style={{ position: 'relative', marginLeft: '10px', flexShrink: 0 }}>
                              <img
                                src={imgDefaultImage}
                                alt={produto.nome}
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'cover',
                                  borderRadius: '8px',
                                  display: 'block'
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: '5px',
                                  right: '5px',
                                  backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                                  borderRadius: '50%',
                                  width: '28px',
                                  height: '28px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid white',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}
                              >
                                <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                              </div>
                            </div>
                          )}

                        </div>
                      ))}
                  </div>
                )}
              </section>
            ))}
        </div>

        <div className="catalogo-assinatura" aria-label="Uma experiência Xeguei">
          <span>uma experiência</span>
          <a href="https://xeguei.com.br" target="_blank" rel="noreferrer">
            xeguei
          </a>
        </div>
      </div>
    );
  };

  function cadastrarProduto(avancarCarrinho: boolean = false, quantidadeSelecionada: number = 1) {
    console.log('[DEBUG] cadastrarProduto START',
      selectedCount,
      selectedProdutos.length,
      listaComporItemsSelecionados.length
    );

    // ✅ CORREÇÃO: Verificar se selectedCategoriaObject existe antes de usar
    if (selectedCategoriaObject?.tipo == "pizzas") {
      if (listaComporItemsSelecionados.length != selectedCount) {
        const texto = selectedCount == 1
          ? "Selecione uma pizza inteira."
          : `Selecione ${selectedCount} partes para compor a pizza.`;
        setTextToast(texto);
        setShowToast(true);
        return false;
      }
    }
    else {
      if (listaComporItemsSelecionados.length != 1) {
        setTextToast("Selecione somente um item para avançar.");
        setShowToast(true);
        return false;
      }
    }

    let isValid = true;
    let errorMessage = '';
    let primeiroGrupoInvalido: number | null = null;

    const registrarErroGrupo = (index: number, mensagem: string) => {
      isValid = false;
      errorMessage += mensagem;
      if (primeiroGrupoInvalido === null) primeiroGrupoInvalido = index;
    };

    if (grupoComplementos) {
      grupoComplementos.forEach((grupo: any, groupIndex: number) => {
        console.log("grupo", grupo);

        if (grupo.obrigatoriedade === "obrigatorio") {
          if (grupo.sizeMax > 1) {
            console.log("checkbox");

            // Verifica se o grupo possui itens selecionados
            if (!grupo.selectedItems || grupo.selectedItems.length === 0) {
              console.log("nenhum item selecionado");
              registrarErroGrupo(groupIndex, `Selecione pelo menos ${grupo.sizeMin} itens para o complemento "${grupo.name}".<br>`);
            } else {
              // Calcula o total de itens selecionados considerando suas quantidades
              const totalSelecionados = grupo.selectedItems.reduce((acc: any, item: any) => acc + (item.quantidade || 0), 0);

              // Verifica se o total selecionado é menor que o mínimo exigido
              if (totalSelecionados < grupo.sizeMin) {
                console.log("menos itens selecionados");
                registrarErroGrupo(groupIndex, `Selecione pelo menos ${grupo.sizeMin} itens para o complemento "${grupo.name}".<br>`);
              }
            }

          }
          else {
            console.log("radiogroup");
            if (!grupo.selectedItem) {
              registrarErroGrupo(groupIndex, `Selecione um item para o complemento ${grupo.name}.<br>`);
            }
          }
        }

      });


      if (!isValid) {
        setTextToast(errorMessage);
        setShowToast(true);
        if (primeiroGrupoInvalido !== null) {
          const groupIndex = primeiroGrupoInvalido;
          requestAnimationFrame(() => { void focarGrupoObrigatorio(groupIndex); });
        }
        return false;
      }
    }

    adicionarProduto(avancarCarrinho, quantidadeSelecionada);
  }

  async function adicionarProduto(avancarCarrinho: boolean = false, quantidadeSelecionada: number = 1) {
    if (showLoading) return;
    console.log('[DEBUG] adicionarProduto START', {
      selectedCategoriaObjectTipo: selectedCategoriaObject?.tipo,
      selectedCount,
      listaComporItemsSelecionados,
      updatedItensSelecionadosComplementos,
      itemSelecionadoMassa,
      itemSelecionadoBorda,
      observacao
    });

    const objectRequest = buildCartItem({
      product: produtoModalComplemento,
      category: selectedCategoriaObject || { nome: selectedCategoria, tipo: 'simples' },
      items: listaComporItemsSelecionados,
      complements: updatedItensSelecionadosComplementos,
      massa: itemSelecionadoMassa, borda: itemSelecionadoBorda,
      observation: observacao, size: selectedSize, flavorCount: selectedCount,
      weightGrams: peso, quantity: quantidadeSelecionada,
      unitPrice: subtotal || valor || '0',
    });
    setShowLoading(true);
    try {
      const added = await props.adicionarItem(objectRequest, avancarCarrinho);
      if (added === false) return;
    } finally {
      setShowLoading(false);
    }

    setQuantidadeModalComplemento(1);
    setShowComplementos(false);
    // ✅ CORREÇÃO: Não chamar limpar() aqui pois pode interferir com outros estados
    // limpar();
  }

  async function deletarItem(index: any) {
    const updatedList = listaComporItemsSelecionados.filter((_: any, i: any) => i !== index);
    setListaComporItemsSelecionados(updatedList);

    const valorFinal = calcularValorTotal(
      updatedItensSelecionadosComplementos,
      updatedList,
      itemSelecionadoMassa,
      itemSelecionadoBorda
    );

    setSubtotal(valorFinal);
    setValor(valorFinal);
  }

  const handleSelectItem = (item: any) => {



    console.log('[DEBUG] handleSelectItem START', {
      item,
      selectedCategoriaObject,
      selectedSize,
      selectedCount,
      listaComporItemsSelecionadosLength: listaComporItemsSelecionados.length
    });

    // ✅ CORREÇÃO: Limpar TODOS os complementos e seleções para garantir estado limpo
    console.log('[DEBUG] limpando TODAS as seleções para estado limpo');
    setSelectedMassa(null);
    setSelectedBorda(null);
    setItemSelecionadoMassa(null);
    setItemSelecionadoBorda(null);
    setUpdatedItensSelecionadosComplementos([]);

    if (grupoComplementos && Array.isArray(grupoComplementos)) {
      const gruposLimpos = grupoComplementos.map((grupo: any) => ({
        ...grupo,
        selectedItem: null, // Resetar seleção de cada grupo
        itens: getGrupoItensDisponiveis(grupo).map((item: any) => ({
          ...item,
          selected: false // Resetar seleção de cada item
        }))
      }));
      setGrupoComplementos(gruposLimpos);
    }

    setGrupoComplementos([]); // Limpar grupos de complementos existentes

    // ✅ CORREÇÃO: Não limpar selectedCategoriaObject aqui pois ele é configurado pela handleProdutoClick


    // ✅ CORREÇÃO: Verificar limite baseado no tipo do item atual (não do estado anterior)
    if (listaComporItemsSelecionados.length >= 1) {
      setTextToast("Selecione somente um item para avançar.");
      setShowToast(true);
      console.log('[DEBUG] bloqueado: já selecionou item');
      return false;
    }

    setUnidadeMedida(item.unidadeMedida || "unid");

    // ✅ CORREÇÃO: Formatação baseada no item atual (não no estado anterior)
    let descricaoFormatada = item.nome ?? item.name ?? '';
    let valorFormatado = precoProdutoVigente(item, cartReferenceDate(cartSchedule())) ?? item.price ?? item.priceFormatted ?? "0,00";

    // Para itens simples, usar formatação padrão
    if (typeof valorFormatado === 'number') {
      valorFormatado = valorFormatado.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const novoItem = {
      id: item.id,
      controlarEstoque: item.controlarEstoque,
      quantidadeEstoque: item.quantidadeEstoque,
      quantidadeMinEstoque: item.quantidadeMinEstoque,
      descricao: descricaoFormatada,
      unidadeMedida: item.unidadeMedida,
      valor: String(valorFormatado),
      categoria: item.categoria,
    };

    if (item.controlarEstoque) {

      if (Number(item.quantidadeMinEstoque) >= Number(item.quantidadeEstoque)) {
        setTextToast("Este produto possui apenas " + item.quantidadeEstoque + " unidade(s) disponível(eis).");
        setShowToast(true);
      }
    }

    console.log('[DEBUG] novoItem preparado', { novoItem });

    let updatedList = [...listaComporItemsSelecionados, novoItem];
    setListaComporItemsSelecionados(updatedList);

    const valorFinal = calcularValorTotal(
      updatedItensSelecionadosComplementos,
      updatedList,
      itemSelecionadoMassa,
      itemSelecionadoBorda
    );

    console.log('[DEBUG] valorFinal após adicionar item', { valorFinal });
    setSubtotal(valorFinal);
    setValor(valorFinal);

    // ✅ CORREÇÃO: Configurar complementos do produto selecionado
    console.log('[DEBUG] verificando complementos do item:', {
      itemNome: item.nome,
      itemTipo: item.tipo,
      itemCategoria: item.categoria,
      grupoComplementos: item.grupoComplementos,
      temComplementos: item.grupoComplementos && Array.isArray(item.grupoComplementos) && item.grupoComplementos.length > 0
    });

    // ✅ CORREÇÃO: Configurar complementos APENAS do produto atual (sem mesclar)
    if (item.grupoComplementos && Array.isArray(item.grupoComplementos) && item.grupoComplementos.length > 0) {
      console.log('[DEBUG] configurando complementos do produto atual', { grupoComplementos: item.grupoComplementos });

      // Carregar APENAS os complementos do produto atual (sem mesclar com existentes)
      // ✅ CORREÇÃO: Preservar estrutura original mas limpar seleções
      const gruposLimpos = prepareGrupoComplementos(item.grupoComplementos);

      setGrupoComplementos(gruposLimpos);
    } else {
      // Se não há complementos do item, inicializar vazio
      console.log('[DEBUG] produto sem complementos específicos');
      setGrupoComplementos([]);
    }
  };

  const closeModal = () => {
    console.log('[DEBUG] closeModal - antes do reset', {
      selectedCategoria,
      selectedCategoriaObjectType: selectedCategoriaObject?.tipo,
      selectedSize,
      selectedCount,
      selectedProdutosLength: selectedProdutos?.length
    });

    setShowSaboresPizzaV2(false);
    setCategoriaExpandida(null);

    console.log('[DEBUG] closeModal - após reset (mantendo size e count)');
  };

  const handleSelectItemMassa = (item: any | null) => {
    if (item === null) {
      // Se o item for desmarcado (null), remove o item selecionado de massa
      setItemSelecionadoMassa(null);

      // Recalcula o valor total sem a massa
      const valorFinal = calcularValorTotal(
        updatedItensSelecionadosComplementos,
        listaComporItemsSelecionados,
        null, // Sem massa
        itemSelecionadoBorda
      );

      setSubtotal(valorFinal);
      setValor(valorFinal);

      return; // Finaliza o fluxo
    }

    // Se um item foi selecionado
    const novoItem = {
      descricao: item.name,
      valor: item.price.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      categoria: "Massa",
    };

    setItemSelecionadoMassa(novoItem);

    // Recalcula o valor total com a massa selecionada
    const valorFinal = calcularValorTotal(
      updatedItensSelecionadosComplementos,
      listaComporItemsSelecionados,
      novoItem,
      itemSelecionadoBorda
    );

    setSubtotal(valorFinal);
    setValor(valorFinal);
  };

  const handleSelectItemBorda = (item: any | null) => {
    if (item === null) {
      // Se o item for desmarcado (null), remove o item selecionado de borda
      setItemSelecionadoBorda(null);

      // Recalcula o valor total sem a borda
      const valorFinal = calcularValorTotal(
        updatedItensSelecionadosComplementos,
        listaComporItemsSelecionados,
        itemSelecionadoMassa,
        null // Sem borda
      );

      setSubtotal(valorFinal);
      setValor(valorFinal);

      return; // Finaliza o fluxo
    }

    // Se um item foi selecionado
    const novoItem = {
      descricao: item.name, // Corrigido de item.nome para item.name
      valor: item.price.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      categoria: "Borda",
    };

    setItemSelecionadoBorda(novoItem);

    // Recalcula o valor total com a borda selecionada
    const valorFinal = calcularValorTotal(
      updatedItensSelecionadosComplementos,
      listaComporItemsSelecionados,
      itemSelecionadoMassa,
      novoItem
    );

    setSubtotal(valorFinal);
    setValor(valorFinal);
  };

  const updateGrupoComplementos = (groupIndex: number, field: string, value: any) => {

    if (Array.isArray(value) && !complementSelectionValid(grupoComplementos[groupIndex], value)) {
      setTextToast('A quantidade selecionada excede o limite deste complemento.');
      setShowToast(true);
      return;
    }

    console.log("value", value);

    const updatedGrupos = [...grupoComplementos];
    updatedGrupos[groupIndex][field] = value;

    // Atualiza o grupo de complementos no estado
    setGrupoComplementos(updatedGrupos);

    // Verificar se um item foi selecionado ou desmarcado
    if (value === null) {
      // Se o valor for null, remover o item correspondente do array
      let updatedItensSelecionados = [...updatedItensSelecionadosComplementos];
      updatedItensSelecionados = updatedItensSelecionados.filter(
        (item) => item.indiceComplemento !== groupIndex
      );

      setUpdatedItensSelecionadosComplementos(updatedItensSelecionados);

      // Recalcular o valor total
      const valorFinal = calcularValorTotal(
        updatedItensSelecionados,
        listaComporItemsSelecionados,
        itemSelecionadoMassa,
        itemSelecionadoBorda
      );

      setSubtotal(valorFinal);
      setValor(valorFinal);

      return; // Finalizar a execução aqui
    }

    // Caso o grupo permita seleção múltipla (sizeMax > 1)
    if (Array.isArray(value)) {
      const selectedItems = value
        .map((itemName: any) => {
          console.log("itemName", itemName);
          const item = updatedGrupos[groupIndex].itens.find(
            (it: any) => it.name === itemName.name
          );

          console.log("encontrou item", item);
          if (item) {
            // Verificar o estoque para itens de seleção múltipla
            const found = listaItemCatalogoProdutosComplementos.find((obj: any) => obj.id === item.id);
            console.log("found estoque item complemento", found);
            if (found && found.controlarEstoque && Number(found.quantidadeMinEstoque) >= Number(found.quantidadeEstoque)) {
              setTextToast(`Este produto possui apenas ${found.quantidadeEstoque} unidade(s) disponível(eis).`);
              setShowToast(true);
            }

            const priceNumerico = parseFloat(
              item.price.toString().replace(/\./g, '').replace(/\,/g, '.')
            );

            return {
              id: item.id,
              groupId: updatedGrupos[groupIndex].id,
              groupIndex: updatedGrupos[groupIndex].sourceGroupIndex ?? groupIndex,
              optionId: item.optionId,
              optionIndex: item.sourceOptionIndex,
              componentQuantity: itemName.quantidade,
              controlarEstoque: item.controlarEstoque,
              quantidadeEstoque: item.quantidadeEstoque,
              quantidadeMinEstoque: item.quantidadeMinEstoque,
              descricao: itemName.quantidade + "x " + item.name,
              valor: (itemName.quantidade * priceNumerico).toLocaleString('pt-br', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              categoria: grupoComplementos[groupIndex].name,
              indiceComplemento: groupIndex,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      // Atualiza o estado removendo itens do grupo atual (groupIndex)
      const updatedState = updatedItensSelecionadosComplementos.filter(
        (item: any) => item.indiceComplemento !== groupIndex
      );

      // Adiciona os itens selecionados ao estado atualizado
      const newState = [...updatedState, ...selectedItems];

      setUpdatedItensSelecionadosComplementos(newState);

      // Recalcula o subtotal considerando o novo estado
      const valorFinal = calcularValorTotal(
        newState,
        listaComporItemsSelecionados,
        itemSelecionadoMassa,
        itemSelecionadoBorda
      );

      setSubtotal(valorFinal);
      setValor(valorFinal);

      return;
    }

    // Identificar o item selecionado dentro do grupo específico
    const selectedItem = updatedGrupos[groupIndex].itens.find((item: any) => item.name === value);

    if (selectedItem) {
      const novoItem = {
        id: selectedItem.id,
        groupId: updatedGrupos[groupIndex].id,
        groupIndex: updatedGrupos[groupIndex].sourceGroupIndex ?? groupIndex,
        optionId: selectedItem.optionId,
        optionIndex: selectedItem.sourceOptionIndex,
        componentQuantity: 1,
        controlarEstoque: selectedItem.controlarEstoque,
        quantidadeEstoque: selectedItem.quantidadeEstoque,
        quantidadeMinEstoque: selectedItem.quantidadeMinEstoque,
        descricao: selectedItem.name,
        valor: selectedItem.price.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        categoria: grupoComplementos[groupIndex].name, // Nome do grupo como categoria
        indiceComplemento: groupIndex,
      };

      console.log("selectedItem", selectedItem);

      // buscar o estoque atual do item com base no id
      const found = listaItemCatalogoProdutosComplementos.find((obj: any) => obj.id === selectedItem.id);

      // Verificar o estoque
      if (found && found.controlarEstoque && Number(found.quantidadeMinEstoque) >= Number(found.quantidadeEstoque)) {
        setTextToast("Este produto possui apenas " + found.quantidadeEstoque + " unidade(s) disponível(eis).");
        setShowToast(true);
      }

      // Atualizar os itens selecionados
      let updatedItensSelecionados = [...updatedItensSelecionadosComplementos];
      const existingItemIndex = updatedItensSelecionados.findIndex(
        (item) => item.indiceComplemento === groupIndex
      );

      if (existingItemIndex !== -1) {
        // Atualizar o item existente
        updatedItensSelecionados[existingItemIndex] = novoItem;
      } else {
        // Adicionar um novo item
        updatedItensSelecionados.push(novoItem);
      }

      // Atualiza o estado com os itens selecionados
      setUpdatedItensSelecionadosComplementos(updatedItensSelecionados);

      // Recalcular o valor total
      const valorFinal = calcularValorTotal(
        updatedItensSelecionados,
        listaComporItemsSelecionados,
        itemSelecionadoMassa,
        itemSelecionadoBorda
      );

      setSubtotal(valorFinal);
      setValor(valorFinal);
    }
  };

  const clearSelectionsComplementos = () => {
    // ✅ CORREÇÃO: Limpar seleções mas preservar estrutura dos grupos
    console.log('[DEBUG] clearSelectionsComplementos - limpando seleções mas preservando estrutura');

    // Limpar seleções mas preservar estrutura dos grupos
    if (grupoComplementos && Array.isArray(grupoComplementos)) {
      const gruposLimpos = grupoComplementos.map((grupo: any) => ({
        ...grupo,
        selectedItem: null, // Resetar seleção de cada grupo
        selectedItems: [], // Resetar seleções múltiplas
        itens: getGrupoItensDisponiveis(grupo).map((item: any) => ({
          ...item,
          selected: false // Resetar seleção de cada item
        }))
      }));
      setGrupoComplementos(gruposLimpos);
    }

    // Limpar todas as seleções relacionadas
    setUpdatedItensSelecionadosComplementos([]);
    setSelectedMassa("");
    setSelectedBorda("");
    setItemSelecionadoMassa("");
    setItemSelecionadoBorda("");

    // Recalcular valor total
    const valorFinal = calcularValorTotal(
      [],
      listaComporItemsSelecionados,
      "",
      ""
    );
    setSubtotal(valorFinal);
    setValor(valorFinal);
  };

  const resetPizzaSelectionState = () => {
    setSelectedSize(undefined);
    setSelectedCount(undefined);
    setCheckedCobrarPorMaiorValor(false);
    setCategoriaExpandida(null);
  };

  const resetComplementosModalState = () => {
    clearSelectionsComplementos();
    resetPizzaSelectionState();

    setSelectedProdutos([]);
    setListaComporItemsSelecionados([]);
    setUpdatedItensSelecionadosComplementos([]);

    setSelectedBorda("");
    setSelectedMassa("");
    setItemSelecionadoBorda("");
    setItemSelecionadoMassa("");
    setObservacao("");
    setPeso("");
    setUnidadeMedida("");

    setProdutoModalComplemento(null);
    setQuantidadeModalComplemento(1);
  };

  const handleCloseComplementosModal = () => {
    setShowComplementos(false);
  };

  // Seleciona pizza destaque para um tamanho e vai direto para complementos
  const selecionarPizzaDestaque = (produto: any, categoria: any, tamanho: string) => {
    // Resetar seleções anteriores
    setSelectedMassa(null);
    setSelectedBorda(null);
    setItemSelecionadoMassa(null);
    setItemSelecionadoBorda(null);
    setUpdatedItensSelecionadosComplementos([]);
    setObservacao("");

    setSelectedProdutos([produto.nome]);
    setSelectedCategoria(categoria.nome);
    setSelectedCategoriaObject(categoria);
    setSelectedSize(tamanho);
    setSelectedCount(1);
    setCheckedCobrarPorMaiorValor(categoria.cobrarMaiorValor || false);
    setCategoriaExpandida(categoria.nome);
    setUnidadeMedida(produto.unidadeMedida || "unid");

    // Calcular preço para o tamanho selecionado
    const valorTamanho = produto.valores?.find((v: any) => v.name === tamanho);
    const precoStr = valorTamanho?.valor ?? produto.valor ?? "0,00";
    const precoNumerico = parseFloat(String(precoStr).replace(/\./g, '').replace(',', '.'));
    const precoFormatado = precoNumerico.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const novoItem = {
      id: produto.id,
      controlarEstoque: produto.controlarEstoque,
      quantidadeEstoque: produto.quantidadeEstoque,
      quantidadeMinEstoque: produto.quantidadeMinEstoque,
      descricao: produto.nome,
      unidadeMedida: produto.unidadeMedida || "unid",
      valor: precoFormatado,
      categoria: produto.categoria,
    };

    setListaComporItemsSelecionados([novoItem]);
    setSubtotal(precoFormatado);
    setValor(precoFormatado);

    // Validação de estoque mínimo (mesma regra de handleSelectItem)
    if (produto.controlarEstoque) {
      if (Number(produto.quantidadeMinEstoque) >= Number(produto.quantidadeEstoque)) {
        setTextToast("Este produto possui apenas " + produto.quantidadeEstoque + " unidade(s) disponível(eis).");
        setShowToast(true);
      }
    }

    // Carregar complementos do produto, filtrando itens sem estoque
    if (produto.grupoComplementos && Array.isArray(produto.grupoComplementos) && produto.grupoComplementos.length > 0) {
      const gruposLimpos = prepareGrupoComplementos(produto.grupoComplementos);
      setGrupoComplementos(gruposLimpos);
    } else {
      setGrupoComplementos([]);
    }

    setProdutoModalComplemento(null);
    setProdutoModalComplemento(produto);
    setQuantidadeModalComplemento(1);
    setShowComplementos(true);
  };

  // Handler para clique em produto destaque
  const handleDestaqueClick = (produto: any) => {
    if (props.disabled) return;

    // Buscar a categoria do produto
    const categoriaDoItem = dadosEmpresa?.categoriaProdutos?.find((cat: any) =>
      cat.nome === produto.categoria || cat.nomeCategoria === produto.categoria
    );

    // Se for pizza, mostrar modal com opções de tamanho (apenas um por tamanho, sem variantes de sabores)
    if (categoriaDoItem?.tipo === "pizzas") {
      const tamanhos = categoriaDoItem.tamanhos || [];

      // Apenas um item por tamanho (sem "2 SABORES", "3 SABORES")
      const opcoesTamanho: any[] = [];
      tamanhos.forEach((tamanho: any) => {
        const temValorParaTamanho = produto.valores?.some((v: any) => v.name === tamanho.name);
        if (!temValorParaTamanho) return;
        opcoesTamanho.push({ nome: tamanho.name.toUpperCase(), tamanho: tamanho.name });
      });

      if (opcoesTamanho.length === 1) {
        // Apenas um tamanho: ir direto para complementos
        selecionarPizzaDestaque(produto, categoriaDoItem, opcoesTamanho[0].tamanho);
      } else {
        // Múltiplos tamanhos: abrir modal de seleção
        setDestaquePizzaProduto({ produto, categoria: categoriaDoItem, combinacoes: opcoesTamanho });
        setShowDestaquePizzaModal(true);
      }
      return;
    }

    // Para produtos não-pizza, seguir fluxo normal
    handleProdutoClick(produto);
  };

  const handleProdutoClick = async (item: any) => {
    console.log("*******handleProdutoClick", item);

    if (props.disabled) {
      return;
    }

    // Analytics: ViewContent
    try { analytics.trackViewContent({ id: item?.id, nome: item?.nome, categoria: item?.categoria, valor: parseFloat(String(item?.valor || 0).replace(/\./g, '').replace(/\,/g, '.')) || 0 }); } catch (e) { /* noop */ }

    // Adicionando novo item
    console.log("selectedProdutos.length", selectedProdutos.length);

    // Adicionar produto e ir direto para complementos
    const itensProdutos = [...selectedProdutos, item.nome];
    setSelectedProdutos(itensProdutos);

    // Configurar categoria do item atual
    const categoriaDoItem = dadosEmpresa?.categoriaProdutos?.find((cat: any) =>
      cat.nome === item.categoria || cat.nomeCategoria === item.categoria
    );

    if (categoriaDoItem?.tipo !== "pizzas") {
      resetPizzaSelectionState();
    }

    if (categoriaDoItem) {
      setSelectedCategoria(categoriaDoItem.nome);
      setSelectedCategoriaObject(categoriaDoItem);

      console.log('[DEBUG] categoriaDoItem configurada:', {
        nome: categoriaDoItem.nome,
        tipo: categoriaDoItem.tipo,
        itemCategoria: item.categoria
      });
    } else {
      setSelectedCategoria(item.categoria || "");
      setSelectedCategoriaObject(null);
    }

    // Processar o item selecionado
    handleSelectItem(item);

    // Abrir complementos para produto simples
    setProdutoModalComplemento(null);
    setProdutoModalComplemento(item);
    setQuantidadeModalComplemento(1);
    setShowComplementos(true);

  };

  const productRequestHandled = useRef<number>();
  const [pendingProductRequest, setPendingProductRequest] = useState<any>(null);
  useEffect(() => {
    const request = props.productRequest;
    if (!request || productRequestHandled.current === request.requestId || !dadosEmpresa || dadosEmpresaOriginais !== props.empresa) return;
    const product = dadosEmpresa.catalogoProdutos?.find((item: any) => item.id === request.productId);
    if (!product) return;
    productRequestHandled.current = request.requestId;
    resetComplementosModalState();
    setPendingProductRequest(product);
    // The requestId is an explicit user action; catalogue updates alone must not reopen a modal.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.productRequest, dadosEmpresa]);

  useEffect(() => {
    if (!pendingProductRequest) return;
    handleDestaqueClick(pendingProductRequest);
    setPendingProductRequest(null);
    // Open on the next render, after the previous selections have been reset.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingProductRequest]);

  function calcularValorTotal(
    updatedItensSelecionadosComplementos: any[],
    listaComporItemsSelecionados: any[],
    itemSelecionadoMassa: any,
    itemSelecionadoBorda: any
  ): string {

    let totalValor = updatedItensSelecionadosComplementos.reduce((total: any, itemCompor: any) => {
      const itemValorNumerico = parseFloat(
        itemCompor.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    console.log("totalValor complementos", totalValor);

    // Calcula o total de listaComporItemsSelecionados
    let totalValorListaSelecionados = 0;

    // ✅ NOVA LÓGICA: Verifica se é pizza com cobrarMaiorValor ativo
    if (selectedCategoriaObject?.tipo === "pizzas" && checkedCobrarPorMaiorValor) {
      // Encontra o maior valor entre os sabores selecionados
      const valoresOriginais = listaComporItemsSelecionados.map((itemCompor: any) => {
        return parseFloat(
          itemCompor.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
      });

      const maiorValor = Math.max(...valoresOriginais);
      const quantidadeSabores = listaComporItemsSelecionados.length;

      console.log("Maior valor encontrado:", maiorValor);
      console.log("Quantidade de sabores:", quantidadeSabores);

      // Para cobrar maior valor: multiplica o maior valor pela quantidade de sabores
      totalValorListaSelecionados = maiorValor * quantidadeSabores;

    } else {
      // Cálculo normal: soma todos os valores
      totalValorListaSelecionados = listaComporItemsSelecionados.reduce((total: number, itemCompor: any) => {
        const itemValorNumerico = parseFloat(
          itemCompor.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
        );

        const valorCalculado =
          itemCompor.unidadeMedida === 'kg'
            ? itemValorNumerico * ((parseFloat(peso.replace(/\./g, '').replace(/\,/g, '.')
            ) || 0) * 0.001)
            : itemValorNumerico;

        return total + valorCalculado;
      }, 0);
    }

    console.log("totalValorListaSelecionados", totalValorListaSelecionados);

    // Soma os totais calculados
    totalValor += totalValorListaSelecionados;

    // Adiciona o valor de itemSelecionadoMassa se existir
    if (itemSelecionadoMassa && itemSelecionadoMassa.valor) {
      totalValor += parseFloat(
        itemSelecionadoMassa.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
    }

    // Adiciona o valor de itemSelecionadoBorda se existir
    if (itemSelecionadoBorda && itemSelecionadoBorda.valor) {
      totalValor += parseFloat(
        itemSelecionadoBorda.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
    }

    // Formata o valor final
    const valorFinal = totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return valorFinal;
  }

  const onChangeValor = (e: any) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");

    setPeso(v);
  };

  const atualizarValor = () => {
    const valorFinal = calcularValorTotal(
      updatedItensSelecionadosComplementos,
      listaComporItemsSelecionados,
      itemSelecionadoMassa,
      itemSelecionadoBorda
    );

    setSubtotal(valorFinal);
    setValor(valorFinal);
  }

  return (

    <>
      {/* <IonCard>
        <IonCardContent style={{ padding: "2px", margin: "2px" }}> */}
      <div style={{ padding: "0px, 6px", margin: "0px 6px" }}>


        <IonGrid>

          <IonRow>
            <IonCol size="12">


              {/* <IonGrid style={{ padding: "0px", margin: "0px" }}>

                  <IonRow style={{ overflowX: 'auto', flexWrap: 'nowrap' }}>
                    {renderCategoriaButtons()}
                  </IonRow>


                </IonGrid> */}

              <div style={{
                position: 'relative',
                paddingBottom: '20px'
              }}>

                {renderProdutos()}

              </div>


            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
      {/* </IonCardContent>
      </IonCard> */}



      <IonModal
        className={`produto-configuracao-modal produto-complementos-modal ${getProdutoModalImagem() ? 'com-imagem' : 'sem-imagem'}`}
        onDidPresent={() => {
          if (pesoInputRef.current) {
            pesoInputRef.current.setFocus();
          }
        }}
        isOpen={showComplementos} onDidDismiss={() => {
          // ✅ CORREÇÃO: Limpar completamente todos os estados ao fechar modal
          console.log('[DEBUG] modal complementos fechado - limpando TODOS os estados');

          resetComplementosModalState();
          setShowComplementos(false);
        }}>

        <IonContent className="complementos-modal-content" ref={complementosContentRef}>
          <div className={`complementos-desktop-layout ${getProdutoModalImagem() ? 'com-imagem' : 'sem-imagem'}`}>
            <IonButton
              className="complementos-modal-back-desktop pedido-fluxo-back-button"
              fill="clear"
              onClick={handleCloseComplementosModal}
            >
              <IonIcon icon={arrowBack} />
            </IonButton>

            <div className="complementos-desktop-media">
              {getProdutoModalImagem() ? (
                <div className="complementos-produto-hero">
                  <img
                    className="complementos-produto-hero-img"
                    src={getProdutoModalImagem() || ""}
                    alt={getProdutoModalTitulo()}
                  />
                  <IonButton
                    className="complementos-produto-back-button pedido-fluxo-back-button"
                    fill="clear"
                    onClick={handleCloseComplementosModal}
                  >
                    <IonIcon icon={arrowBack} />
                  </IonButton>
                </div>
              ) : (
                <div className="complementos-produto-topbar-sem-imagem">
                  <IonButton
                    className="complementos-produto-back-button-sem-imagem pedido-fluxo-back-button"
                    fill="clear"
                    onClick={handleCloseComplementosModal}
                  >
                    <IonIcon icon={arrowBack} />
                  </IonButton>
                </div>
              )}
            </div>

            <div className="complementos-desktop-panel">
              <div className="complementos-produto-info">
                {!!getProdutoModalTitulo() && (
                  <h1>{getProdutoModalTitulo()}</h1>
                )}
                <ProductBadges badges={getProdutoDestaques(produtoModalComplemento)} />
                {!!getProdutoModalDescricao() && (
                  <p>{getProdutoModalDescricao()}</p>
                )}
                <div className="complementos-produto-preco-desktop">
                  R$ {getTotalModalComQuantidade()}
                </div>
                {selectedCategoriaObject?.tipo === "pizzas" && selectedSize && selectedCount === 1 && (
                  <span className="complementos-produto-tamanho">
                    {selectedSize} - {selectedCount} sabor
                  </span>
                )}
              </div>

              {selectedCategoriaObject?.tipo === "pizzas" && selectedCount > 1 && getProdutoModalSaboresPills().length > 0 && (
                <div className="complementos-produto-sabores-pills">
                  {getProdutoModalSaboresPills().map((sabor: string, index: number) => (
                    <span key={index} className="complementos-produto-sabor-pill">
                      {sabor}
                    </span>
                  ))}
                </div>
              )}

              <IonGrid style={{ padding: "8px", width: "100%" }}>

                <IonRow hidden={!(unidadeMedida == "kg")}>
                  <IonCol size="12">
                    <IonLabel style={{ fontWeight: 'bold' }}>Peso (g)</IonLabel>
                  </IonCol>
                </IonRow>

                <IonRow hidden={!(unidadeMedida == "kg")}>
                  <IonCol size="12">

                    <IonInput
                      type="tel"
                      maxlength={14}
                      placeholder="Digite o valor"
                      value={peso}
                      onIonChange={(e: any) => onChangeValor(e)}
                      onIonBlur={() => atualizarValor()}
                      ref={pesoInputRef}
                    />
                  </IonCol>
                </IonRow>
              </IonGrid>

              {selectedCategoriaObject?.tipo === "pizzas" && (
                <IonGrid style={{ padding: "8px", width: "100%" }}>

                  {/* Seção de Massa - só exibe se houver itens */}
                  {selectedCategoriaObject?.massas && selectedCategoriaObject.massas.length > 0 && (
                    <IonRow>
                      <IonCol id="complemento-group-massa" size="12">
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <IonLabel style={{ fontWeight: 'bold', color: "black" }}>Massa</IonLabel>
                          <IonButton
                            fill="outline"
                            size="small"
                            color="primary"
                            onClick={() => {
                              // Reseta a massa selecionada
                              setSelectedMassa(null);
                              handleSelectItemMassa(null); // Limpa o item selecionado
                            }}
                          >
                            Limpar
                          </IonButton>
                        </div>
                        <IonRadioGroup
                          value={selectedMassa}
                          onIonChange={(e: any) => {
                            const selectedValue = e.detail.value;
                            setSelectedMassa(selectedValue);

                            // Encontra o item selecionado ou lida com o desmarque (null)
                            const selectedMassaItem = selectedValue
                              ? selectedCategoriaObject?.massas?.find(
                                (massa: any) => massa.name === selectedValue
                              )
                              : null;

                            handleSelectItemMassa(selectedMassaItem);

                            if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '') {
                              avancarParaProximoGrupo('complemento-group-massa');
                            }
                          }}
                        >
                          {selectedCategoriaObject?.massas?.map((massa: any, index: any) => (
                            <IonItem key={index} lines="none" style={{ fontSize: "12px" }}>
                              <IonRadio slot="start" value={massa.name} />
                              <IonLabel>{massa.name} - {massa.price}</IonLabel>
                            </IonItem>
                          ))}
                        </IonRadioGroup>
                      </IonCol>
                    </IonRow>
                  )}

                  {/* Seção de Borda - só exibe se houver itens */}
                  {selectedCategoriaObject?.bordas && selectedCategoriaObject.bordas.length > 0 && (
                    <IonRow>
                      <IonCol id="complemento-group-borda" size="12">
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <IonLabel style={{ fontWeight: 'bold', color: "black" }}>Borda</IonLabel>
                          <IonButton
                            fill="outline"
                            size="small"
                            color="primary"
                            onClick={() => {
                              // Reseta a borda selecionada
                              setSelectedBorda(null);
                              handleSelectItemBorda(null); // Limpa o item selecionado
                            }}
                          >
                            Limpar
                          </IonButton>
                        </div>
                        <IonRadioGroup
                          value={selectedBorda}
                          onIonChange={(e: any) => {
                            const selectedValue = e.detail.value;
                            setSelectedBorda(selectedValue);

                            // Encontra o item selecionado ou lida com o desmarque (null)
                            const selectedBordaItem = selectedValue
                              ? selectedCategoriaObject?.bordas?.find(
                                (borda: any) => borda.name === selectedValue
                              )
                              : null;

                            handleSelectItemBorda(selectedBordaItem);

                            if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '') {
                              avancarParaProximoGrupo('complemento-group-borda');
                            }
                          }}
                        >
                          {selectedCategoriaObject?.bordas?.map((borda: any, index: any) => (
                            <IonItem key={index} lines="none" style={{ fontSize: "12px" }}>
                              <IonRadio slot="start" value={borda.name} />
                              <IonLabel>{borda.name} - {borda.price}</IonLabel>
                            </IonItem>
                          ))}
                        </IonRadioGroup>
                      </IonCol>
                    </IonRow>
                  )}

                </IonGrid>
              )}

              {/* Complementos */}
              {grupoComplementos && Array.isArray(grupoComplementos) && grupoComplementos.length > 0 && (
                <IonGrid style={{ padding: "8px", width: "100%" }}>
                  <IonRow>
                    {grupoComplementos.map((grupo: any, groupIndex: number) => {
                      // Calcula a quantidade de itens selecionados
                      const totalSelecionados = (grupo.selectedItems?.reduce((acc: number, item: any) => acc + item.quantidade, 0) || 0);

                      return (
                        <IonCol key={groupIndex} id={`complemento-group-${groupIndex}`} className="complementos-grupo-opcoes" size="12" tabIndex={-1} role="group" aria-label={`Complemento ${grupo.name}`}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <IonLabel>
                              <span style={{ fontWeight: 'bold' }}>
                                {grupo.name}
                                {grupo.sizeMax > 1 && ` (${totalSelecionados}/${grupo.sizeMax})`}
                              </span>
                              <div style={{ marginTop: '0px', fontSize: "14px" }}>
                                {grupo.obrigatoriedade === 'obrigatorio' && (
                                  <span>
                                    Escolha {grupo.sizeMin === 1 ? `${grupo.sizeMin} opção` : `${grupo.sizeMin} opções`}
                                  </span>
                                )}
                              </div>
                            </IonLabel>

                            <IonButton
                              fill="outline"
                              size="small"
                              color="primary"
                              onClick={() => {
                                if (grupo.sizeMax > 1) {
                                  updateGrupoComplementos(groupIndex, 'selectedItems', []);
                                } else {
                                  updateGrupoComplementos(groupIndex, 'selectedItem', null);
                                }
                              }}
                            >
                              Limpar
                            </IonButton>
                          </div>

                          {/* Multi-seleção ou seleção única */}
                          {grupo.sizeMax > 1 ? (
                            <div>
                              {getGrupoItensDisponiveis(grupo).map((item: any, itemIndex: number) => {
                                const quantidade = grupo.selectedItems?.find((it: any) => it.name === item.name)?.quantidade || 0;
                                const limiteOpcao = complementOptionMaximum(grupo, item);

                                return (
                                  <IonItem
                                    key={itemIndex}
                                    lines="full"
                                    style={{ fontSize: "13px", "--padding-start": "0", "--inner-padding-end": "0" }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        padding: "12px 16px"
                                      }}
                                    >
                                      {/* ESQUERDA: NOME + DESCRIÇÃO + PREÇO */}
                                      <div style={{ flex: 1, minWidth: 0, marginRight: "12px" }}>
                                        <div style={{ fontWeight: 500, fontSize: "14px", wordBreak: "break-word" }}>
                                          {item.name}
                                        </div>
                                        {item.description && (
                                          <div style={{ fontSize: "12px", color: "var(--pedido-text-muted)", marginTop: "2px", lineHeight: "1.3" }}>
                                            {item.description}
                                          </div>
                                        )}
                                        <div style={{ fontSize: "13px", color: "var(--pedido-text-secondary)", marginTop: "4px" }}>
                                          + R$ {item.price}
                                        </div>
                                      </div>

                                      {/* DIREITA: STEPPER */}
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "10px",
                                          flexShrink: 0
                                        }}
                                      >
                                        <IonIcon
                                          icon={remove}
                                          color="danger"
                                          style={{ fontSize: "20px", cursor: "pointer" }}
                                          onClick={() => {
                                            if (quantidade > 0) {
                                              const selectedItems = [...(grupo.selectedItems || [])];
                                              const idx = selectedItems.findIndex((it: any) => it.name === item.name);
                                              if (idx !== -1) {
                                                selectedItems[idx].quantidade -= 1;
                                                if (selectedItems[idx].quantidade === 0) selectedItems.splice(idx, 1);
                                              }
                                              updateGrupoComplementos(groupIndex, "selectedItems", selectedItems);
                                            }
                                          }}
                                        />
                                        <span style={{ fontWeight: "bold", fontSize: "15px", minWidth: "18px", textAlign: "center" }}>
                                          {quantidade}
                                        </span>
                                        <IonIcon
                                          icon={add}
                                          color="success"
                                          aria-disabled={quantidade >= limiteOpcao || totalSelecionados >= grupo.sizeMax}
                                          style={{ fontSize: "20px", cursor: quantidade >= limiteOpcao ? "not-allowed" : "pointer", opacity: quantidade >= limiteOpcao ? 0.4 : 1 }}
                                          onClick={() => {
                                            if (quantidade >= limiteOpcao) {
                                              setTextToast(`Você pode selecionar até ${limiteOpcao} unidade(s) desta opção.`);
                                              setShowToast(true);
                                              return;
                                            }
                                            if (totalSelecionados < grupo.sizeMax) {
                                              const selectedItems = [...(grupo.selectedItems || [])];
                                              const idx = selectedItems.findIndex((it: any) => it.name === item.name);
                                              if (idx !== -1) {
                                                selectedItems[idx].quantidade += 1;
                                              } else {
                                                selectedItems.push({ name: item.name, quantidade: 1 });
                                              }
                                              updateGrupoComplementos(groupIndex, "selectedItems", selectedItems);

                                              const novoTotalSelecionados = selectedItems.reduce(
                                                (acc: number, item: any) => acc + (item.quantidade || 0),
                                                0
                                              );

                                              if (novoTotalSelecionados >= grupo.sizeMax) {
                                                avancarParaProximoGrupo(`complemento-group-${groupIndex}`);
                                              }
                                            } else {
                                              setTextToast(`Você só pode selecionar até ${grupo.sizeMax} itens.`);
                                              setShowToast(true);
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </IonItem>
                                );
                              })}
                            </div>
                          ) : (
                            <IonRadioGroup
                              value={grupo.selectedItem}
                              onIonChange={(e: any) => {
                                const selectedValue = e.detail.value;
                                updateGrupoComplementos(groupIndex, 'selectedItem', selectedValue);

                                if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '') {
                                  avancarParaProximoGrupo(`complemento-group-${groupIndex}`);
                                }
                              }}
                            >
                              {getGrupoItensDisponiveis(grupo)
                                .map((item: any, itemIndex: number) => {
                                  return (
                                    <IonItem
                                      key={itemIndex}
                                      lines="full"
                                      style={{ fontSize: "13px", "--padding-start": "0", "--inner-padding-end": "0" }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          width: "100%",
                                          padding: "12px 16px"
                                        }}
                                      >
                                        {/* ESQUERDA: NOME + PREÇO */}
                                        <div style={{ flex: 1, minWidth: 0, marginRight: "12px" }}>
                                          <div style={{ fontWeight: 500, fontSize: "14px", wordBreak: "break-word" }}>
                                            {item.name}
                                          </div>
                                          {item.description && (
                                            <div style={{ fontSize: "12px", color: "var(--pedido-text-muted)", marginTop: "2px", lineHeight: "1.3" }}>
                                              {item.description}
                                            </div>
                                          )}
                                          <div style={{ fontSize: "13px", color: "var(--pedido-text-secondary)", marginTop: "4px" }}>
                                            + R$ {item.price}
                                          </div>
                                        </div>

                                        {/* DIREITA: RADIO */}
                                        <IonRadio
                                          value={item.name}
                                          style={{ flexShrink: 0 }}
                                        />
                                      </div>
                                    </IonItem>
                                  );
                                })}
                            </IonRadioGroup>
                          )}
                        </IonCol>
                      );
                    })}
                  </IonRow>
                </IonGrid>
              )}

              <IonGrid className="complementos-observacao" style={{ padding: "8px", width: "100%" }}>
                <IonRow>
                  <IonCol size="12">
                    <div className="complementos-observacao-header">
                      <span>Alguma observação?</span>
                      <span>{observacao.length} / 140</span>
                    </div>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="12">

                    <IonTextarea
                      style={{ "--background": "var(--pedido-gray-surface)", "borderRadius": "5px" }}
                      rows={2}
                      autoCorrect='true' autoCapitalize='true'
                      value={observacao}
                      maxlength={140}
                      placeholder="Alguma observação?"
                      onIonInput={(e: any) => setObservacao(e.target.value)}
                    ></IonTextarea>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="12" style={{ textAlign: 'right' }}>
                    <IonLabel></IonLabel>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
          </div>
        </IonContent>
        <IonFooter className={`ion-no-border complementos-footer-compacto ${getProdutoModalImagem() ? 'com-imagem' : 'sem-imagem'}`}>

          <IonToolbar className="complementos-footer-toolbar">
            <div className="complementos-footer-row">
              <div className="complementos-quantidade-stepper">
                <IonButton
                  fill="clear"
                  className="complementos-quantidade-btn"
                  disabled={quantidadeModalComplemento <= 1}
                  onClick={() => {
                    setQuantidadeModalComplemento((prev) => Math.max(1, prev - 1));
                  }}
                >
                  <IonIcon icon={remove} />
                </IonButton>

                <span className="complementos-quantidade-value">
                  {quantidadeModalComplemento}
                </span>

                <IonButton
                  fill="clear"
                  className="complementos-quantidade-btn"
                  onClick={() => {
                    setQuantidadeModalComplemento((prev) => prev + 1);
                  }}
                >
                  <IonIcon icon={add} />
                </IonButton>
              </div>

              <div className="complementos-adicionar-wrap">
                <IonButton
                  className="complementos-adicionar-btn"
                  expand="block"
                  type="button"
                  color="primary"
                  onClick={() => {
                    cadastrarProduto(false, quantidadeModalComplemento);
                  }}
                >
                  Adicionar R$ {getTotalModalComQuantidade()}
                </IonButton>
              </div>
            </div>

            {/*
            <IonList style={{ padding: "0px", margin: "0px" }} >
              <IonItem style={{ padding: "0px", margin: "0px" }} lines="none">
                <IonLabel slot="start" style={{ fontWeight: 'bold' }}>Valor Total:</IonLabel>
                <IonLabel slot="end">{subtotal || "0"}</IonLabel>
              </IonItem>
            </IonList>

            <IonButton
              style={{ height: "46px", fontSize: "18px", marginBottom: "8px" }}
              onClick={() => {
                cadastrarProduto(false);
              }}
              expand="block"
              type="submit"
              fill="outline"
            >
              Continuar comprando
            </IonButton>

            <IonButton
              style={{ height: "46px", fontSize: "18px" }}
              onClick={() => {
                cadastrarProduto(true);
              }}
              expand="block"
              type="submit"
              color="primary"
            >
              Avançar para o carrinho
            </IonButton>
            */}
          </IonToolbar>
        </IonFooter>


      </IonModal>


      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />

      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />


      {/* IonModal para exibir a categoria expandida */}
      <IonModal className="produto-configuracao-modal" isOpen={showSaboresPizza} onDidDismiss={closeModal}>
        <IonHeader className="ion-no-border">
          <IonToolbar className="pedido-fluxo-modal-toolbar">
            <IonButtons slot="start" className="pedido-fluxo-back-buttons">
              <IonButton
                className="pedido-fluxo-back-button"
                fill="clear"
                onClick={() => {
                  closeModal();
                }}
              >
                <IonIcon icon={arrowBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>{selectedCategoriaObject ? getNomeCategoriaExibicao(selectedCategoriaObject) : categoriaExpandida}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {/* Sabores de pizza para seleção */}
          {categoriaExpandida && dadosEmpresa?.catalogoProdutos && (
            <div style={{ padding: '15px' }}>
              {/* Header com informações da pizza */}
              <div style={{
                backgroundColor: 'var(--pedido-gray-surface)',
                borderRadius: '8px',
                padding: '10px',
                marginBottom: '20px'
              }}>
                <h2 style={{ margin: '0 0 5px 0', fontSize: '18px', fontWeight: 'bold', color: 'var(--pedido-text-primary)' }}>
                  {formatarNomeOpcaoComposta(selectedSize, selectedCount)}
                </h2>
                <p style={{ margin: '0', fontSize: '14px', color: 'var(--pedido-text-secondary)' }}>
                  Selecione o(s) sabor(es) desejado(s)
                </p>
              </div>

              {/* Lista de sabores disponíveis */}
              <div>
                {dadosEmpresa.catalogoProdutos
                  .filter((produto: any) => {
                    return produto.tipo === "pizzas" &&
                      produto.categoria === categoriaExpandida &&
                      isProdutoDisponivel(produto) &&
                      produto.valores?.some((v: any) => v.name === selectedSize);
                  })
                  .map((produto: any, index: number) => {
                    // Encontrar o preço para o tamanho selecionado
                    const valorTamanho = produto.valores?.find((v: any) => v.name === selectedSize);
                    const oferta = ofertaSaborPizza(valorTamanho, referenciaPromocao, selectedCount || 1);
                    const preco = valorTamanho ? valorTamanho.valor : "0,00";

                    // Calcular o preço dividido pelo número de sabores quando selectedCount > 1
                    const precoNumerico = parseFloat(preco.replace(/\./g, '').replace(/\,/g, '.'));
                    const precoDividido = selectedCount > 1 ? precoNumerico / selectedCount : precoNumerico;
                    const precoIntegral = precoDividido.toLocaleString('pt-br', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    });

                    // Verificar se o produto está selecionado
                    const isSelected = selectedProdutos.includes(produto.nome);

                    return (
                      <div
                        key={index}
                        onClick={() => {
                          console.log("🍕 Sabor clicado:", produto.nome);
                          console.log("🍕 Estado atual - selectedProdutos:", selectedProdutos);
                          console.log("🍕 Limite de sabores:", selectedCount);

                          if (isSelected) {
                            // Remover sabor selecionado
                            const novosSelecionados = selectedProdutos.filter((nome: string) => nome !== produto.nome);
                            setSelectedProdutos(novosSelecionados);
                            console.log("🍕 Sabor removido:", produto.nome);
                            console.log("🍕 Novos selecionados:", novosSelecionados);
                          } else {
                            // Adicionar sabor se não exceder o limite
                            if (selectedProdutos.length < selectedCount) {
                              const novosSelecionados = [...selectedProdutos, produto.nome];
                              setSelectedProdutos(novosSelecionados);
                              console.log("🍕 Sabor adicionado:", produto.nome);
                              console.log("🍕 Novos selecionados:", novosSelecionados);
                            }
                            // else {
                            //   console.log("🍕 Limite de sabores atingido");
                            //   setTextToast(`Você só pode selecionar ${selectedCount} sabor(es)`);
                            //   setShowToast(true);
                            // }
                          }
                        }}
                        style={{
                          backgroundColor: 'white',
                          borderRadius: '8px',
                          padding: '10px',
                          marginBottom: '10px',
                          border: isSelected ? "2px solid var(--ion-color-primary)" : "1px solid var(--pedido-gray-border)",
                          cursor: 'pointer',
                          opacity: (!isSelected && selectedProdutos.length >= selectedCount) ? 0.5 : 1
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <h3 style={{
                              fontSize: '16px',
                              fontWeight: 'bold',
                              marginBottom: '5px',
                              margin: 0,
                              color: 'var(--pedido-text-primary)'
                            }}>
                              {produto.nome}
                              {/* {isSelected && selectedCount > 1 && (
                                <span>
                                  {' '}(1/{selectedCount})
                                </span>
                              )} */}
                            </h3>
                            <ProductBadges badges={produto.destaquesProduto} />
                            {produto.descricao && (
                              <p style={{
                                fontSize: '13px',
                                color: 'var(--pedido-text-secondary)',
                                padding: '5px 5px 5px 0px',
                                marginBottom: '5px',
                                margin: 0
                              }}>
                                {produto.descricao}
                              </p>
                            )}
                            <div style={{
                              fontSize: '14px',
                              fontWeight: 'bold',
                              color: 'var(--pedido-text-primary)'
                            }}>
                              {oferta ? <PrecoPromocional oferta={oferta} /> : <>R$ {precoIntegral}</>}
                            </div>
                          </div>
                          {produto.urlImagem ? (
                            <div style={{ position: 'relative', marginLeft: '10px', flexShrink: 0 }}>
                              <img
                                src={produto.urlImagem}
                                alt={produto.nome}
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'cover',
                                  borderRadius: '8px',
                                  display: 'block'
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: '5px',
                                  right: '5px',
                                  backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                                  borderRadius: '50%',
                                  width: '28px',
                                  height: '28px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid white',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}
                              >
                                <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                              </div>
                            </div>
                          ) : (
                            <div style={{ position: 'relative', marginLeft: '10px', flexShrink: 0 }}>
                              <img
                                src={imgDefaultImage}
                                alt={produto.nome}
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'cover',
                                  borderRadius: '8px',
                                  display: 'block'
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: '5px',
                                  right: '5px',
                                  backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                                  borderRadius: '50%',
                                  width: '28px',
                                  height: '28px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid white',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}
                              >
                                <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>

              {/* Resumo da seleção */}
              {/* {selectedProdutos.length > 0 && (
                <div style={{
                  backgroundColor: 'var(--pedido-gray-surface)',
                  borderRadius: '8px',
                  padding: '15px',
                  marginTop: '20px',
                  border: '1px solid var(--pedido-gray-border)'
                }}>
                  <h4 style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: 'bold', color: 'var(--pedido-text-primary)' }}>
                    Resumo da Pizza:
                  </h4>
                  {selectedProdutos.map((saborNome: string, index: number) => {
                    const produto = dadosEmpresa.catalogoProdutos.find((p: any) => p.nome === saborNome);
                    const valorTamanho = produto?.valores?.find((v: any) => v.name === selectedSize);
                    const preco = valorTamanho ? valorTamanho.valor : "0,00";

                    // Calcular o preço dividido pelo número de sabores quando selectedCount > 1
                    const precoNumerico = parseFloat(preco.replace(/\./g, '').replace(/\,/g, '.'));
                    const precoDividido = selectedCount > 1 ? precoNumerico / selectedCount : precoNumerico;
                    const precoFormatado = precoDividido.toLocaleString('pt-br', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    });

                    return (
                      <div key={index} style={{
                        fontSize: '14px',
                        color: 'var(--pedido-text-secondary)',
                        marginBottom: '5px'
                      }}>
                        {selectedCount > 1 ? `- 1/${selectedCount} ${saborNome} (R$ ${precoFormatado})` : `- ${saborNome} (R$ ${precoFormatado})`}
                      </div>
                    );
                  })}
                </div>
              )} */}

            </div>
          )}
        </IonContent>
        <IonFooter className="ion-no-border" style={{ borderTop: '1px solid var(--pedido-gray-border)' }}>
          <IonToolbar style={{ padding: '10px' }}>
            {(checkedCobrarPorMaiorValor && selectedCategoriaObject?.tipo === 'pizzas') && (
              <div style={{
                background: 'var(--pedido-gray-surface)',
                color: 'var(--pedido-text-secondary)',
                border: '1px solid var(--pedido-text-secondary)',
                borderRadius: '6px',
                padding: '10px 12px',
                margin: '0 2px 12px 2px',
                fontSize: '15px',
                fontWeight: 500
              }}>
                Em pizzas com mais de um sabor, o valor cobrado será o do sabor de maior valor.
              </div>
            )}
            <IonButton
              style={{ height: "46px", fontSize: "18px" }}
              expand="block"
              type="submit"
              disabled={selectedProdutos.length !== selectedCount}
              onClick={() => {
                if (selectedProdutos.length !== selectedCount) {
                  setTextToast(`Selecione ${selectedCount} sabores para continuar.`);
                  setShowToast(true);
                  return;
                }

                console.log("✅ Finalizando seleção de sabores", selectedProdutos);

                const criarItemPizza = (produto: any) => {
                  const valorTamanho = produto.valores?.find((v: any) => v.name === selectedSize);
                  const preco = valorTamanho ? valorTamanho.valor : "0,00";
                  const precoPorSabor = (parseFloat(preco.replace(',', '.')) / selectedCount)
                    .toFixed(2)
                    .replace('.', ',');

                  return {
                    id: produto.id,
                    controlarEstoque: produto.controlarEstoque,
                    quantidadeEstoque: produto.quantidadeEstoque,
                    quantidadeMinEstoque: produto.quantidadeMinEstoque,
                    descricao: selectedCount > 1 ? `1/${selectedCount} ${produto.nome}` : produto.nome,
                    valor: precoPorSabor,
                    categoria: produto.categoria,
                    unidadeMedida: produto.unidadeMedida || "unid"
                  };
                };

                const novosItens = selectedProdutos
                  .map((saborNome: string) => {
                    const produto = dadosEmpresa?.catalogoProdutos?.find((p: any) =>
                      p.nome === saborNome &&
                      p.tipo === "pizzas" &&
                      p.categoria === categoriaExpandida &&
                      isProdutoDisponivel(p)
                    );
                    return produto ? criarItemPizza(produto) : null;
                  })
                  .filter(Boolean);

                const updatedList = [...listaComporItemsSelecionados, ...novosItens];
                setListaComporItemsSelecionados(updatedList);

                const valorFinal = calcularValorTotal(
                  updatedItensSelecionadosComplementos,
                  updatedList,
                  itemSelecionadoMassa,
                  itemSelecionadoBorda
                );
                setSubtotal(valorFinal);
                setValor(valorFinal);

                // ✅ CORREÇÃO: Carregar complementos APENAS do último sabor selecionado (sem acumular)
                console.log('[DEBUG] carregando complementos do último sabor selecionado');

                // pega o nome do último sabor selecionado
                const ultimoSaborNome = selectedProdutos[selectedProdutos.length - 1];
                let produtoUltimoSelecionado: any = null;
                console.log('DEBUG -> ultimoSaborNome', ultimoSaborNome);

                if (ultimoSaborNome) {
                  const produtoUltimo = dadosEmpresa?.catalogoProdutos?.find((p: any) =>
                    p.nome === ultimoSaborNome &&
                    p.tipo === "pizzas" &&
                    p.categoria === categoriaExpandida &&
                    isProdutoDisponivel(p)
                  );
                  produtoUltimoSelecionado = produtoUltimo;

                  console.log('DEBUG -> produtoUltimo encontrado:', produtoUltimo?.nome);

                  // Carregar APENAS os complementos do último produto (sem acumular)
                  if (produtoUltimo?.grupoComplementos?.length) {
                    console.log('[DEBUG] configurando complementos do último sabor:', produtoUltimo.grupoComplementos);
                    setGrupoComplementos(prepareGrupoComplementos(produtoUltimo.grupoComplementos));
                  } else {
                    console.log('[DEBUG] último sabor sem complementos');
                    setGrupoComplementos([]);
                  }
                } else {
                  console.log('[DEBUG] nenhum sabor selecionado');
                  setGrupoComplementos([]);
                }

                // abrir modal de complementos
                setProdutoModalComplemento(null);
                if (selectedCount === 1) {
                  setProdutoModalComplemento(produtoUltimoSelecionado || null);
                }
                setQuantidadeModalComplemento(1);
                closeModal();
                setShowComplementos(true);
              }}
            >
              Continuar ({selectedProdutos.length}/{selectedCount})
            </IonButton>

          </IonToolbar>
        </IonFooter>
      </IonModal>

      {/* Modal para seleção de tamanho/sabores de pizza em destaque */}
      <IonModal className="produto-configuracao-modal produto-selecao-modal" isOpen={showDestaquePizzaModal} onDidDismiss={() => { setShowDestaquePizzaModal(false); setDestaquePizzaProduto(null); }}>
        <IonHeader className="ion-no-border">
          <IonToolbar className="pedido-fluxo-modal-toolbar">
            <IonButtons slot="start" className="pedido-fluxo-back-buttons">
              <IonButton
                className="pedido-fluxo-back-button"
                fill="clear"
                onClick={() => {
                  setShowDestaquePizzaModal(false);
                  setDestaquePizzaProduto(null);
                }}
              >
                <IonIcon icon={arrowBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>{destaquePizzaProduto?.categoria?.nome || 'Pizzas'}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {destaquePizzaProduto?.combinacoes?.map((combinacao: any, comboIndex: number) => {
            // Preço do produto destaque para este tamanho
            const valorTamanho = destaquePizzaProduto.produto.valores?.find((v: any) => v.name === combinacao.tamanho);
            const oferta = ofertaSaborPizza(valorTamanho, referenciaPromocao);
            const precoNumerico = valorTamanho
              ? parseFloat(String(valorTamanho.valor).replace(/\./g, '').replace(',', '.'))
              : 0;
            const precoFormatado = precoNumerico > 0 ? precoNumerico.toFixed(2).replace('.', ',') : '0,00';

            // Imagem do produto com fallback para a categoria
            const imageUrl = destaquePizzaProduto.produto.urlImagem || destaquePizzaProduto.categoria?.urlImagem;

            return (
              <div
                key={comboIndex}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '15px',
                  margin: '10px',
                  border: '1px solid var(--pedido-gray-border)',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  const prod = destaquePizzaProduto.produto;
                  const cat = destaquePizzaProduto.categoria;
                  setShowDestaquePizzaModal(false);
                  setDestaquePizzaProduto(null);
                  selecionarPizzaDestaque(prod, cat, combinacao.tamanho);
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{ fontSize: '16px', fontWeight: 'bold', margin: 0, color: 'var(--pedido-text-primary)' }}>
                    {combinacao.nome}
                  </h3>
                  <ProductBadges badges={getProdutoDestaques(destaquePizzaProduto.produto)} />
                  <div style={{ fontSize: '14px', fontWeight: 'bold', color: 'var(--pedido-text-primary)', marginTop: '4px' }}>
                    {oferta ? <PrecoPromocional oferta={oferta} /> : <>R$ {precoFormatado}</>}
                  </div>
                </div>

                {imageUrl ? (

                  <div style={{ position: 'relative', marginLeft: '10px', flexShrink: 0 }}>
                    <img
                      src={imageUrl}
                      alt={combinacao.nome}
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        display: 'block'
                      }}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '5px',
                        right: '5px',
                        backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}
                    >
                      <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                    </div>
                  </div>


                ) : (
                  <div style={{ position: 'relative', marginLeft: '10px', flexShrink: 0 }}>
                    <img
                      src={imgDefaultImage}
                      // alt={produto.nome}
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        display: 'block'
                      }}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '5px',
                        right: '5px',
                        backgroundColor: 'var(--ion-color-primary, --ion-color-success)',
                        borderRadius: '50%',
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                      }}
                    >
                      <IonIcon icon={add} style={{ color: 'white', fontSize: '16px' }} />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </IonContent>
      </IonModal>

    </>
  );


};

export default OrdensProdutosCompor;
